import momentJalali from "moment-jalaali"
// import momentHijri from "moment-hijri"
import * as momentRange from "moment-range"

let momentWithRange =
  momentRange.extendMoment(momentJalali)

export const setMoment = (lang = "fa") => {
  momentWithRange =
    momentRange.extendMoment(
      // lang === "ar" ? momentHijri :
      momentJalali
    )
}

const moment = (date) => {
  const d = date || undefined

  return momentWithRange(d)
}

export default moment